
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import Taz from "../tiles/Taz";
import UIButton from "../../components/core/UIButton";
import Game from "../../scenes/Game";
import { DebugInput } from "~/js/scenes/DebugInput";

export const TutorialSteps = {
  None:'none',
  MovePlayer: 'movePlayer',
  MovePlayerInMotion: 'movePlayerInMotion',
  PressPowerup: 'pressPowerup',
  PressBumper: 'pressBumper'
} as const;


const events = {
  pausableTutorialStepStarted: 'pausableTutorialStepStarted',
  tutorialStepCompleted: 'tutorialStepCompleted',
  idlePrompt: 'idlePrompt',
} as const;

export type TutorialStepsKeys = keyof typeof TutorialSteps;
export type TutorialStepsValues = typeof TutorialSteps[TutorialStepsKeys];

/* END-USER-IMPORTS */

export default class Tutorial extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // tutorialPointer
    const tutorialPointer = scene.add.container(960, 384);
    this.add(tutorialPointer);

    // hand
    const hand = scene.add.image(0, 0, "common", "help-hand.png");
    hand.setOrigin(0.11, 0.08);
    tutorialPointer.add(hand);

    // pointer
    const pointer = scene.add.image(0, 0, "common", "help-pointer.png");
    pointer.setOrigin(0.06, 0.05);
    tutorialPointer.add(pointer);

    this.tutorialPointer = tutorialPointer;
    this.hand = hand;
    this.pointer = pointer;

    /* START-USER-CTR-CODE */
    this.tutorialPointer.visible = false;
    
    /* END-USER-CTR-CODE */
  }

  private tutorialPointer: Phaser.GameObjects.Container;
  private hand: Phaser.GameObjects.Image;
  private pointer: Phaser.GameObjects.Image;

  /* START-USER-CODE */
  public static events = events;
  private game!:Game;
  private taz!:Taz;
  private tutorialTween!:Phaser.Tweens.TweenChain | undefined;
  private idleTween!:Phaser.Tweens.TweenChain | undefined;
  private powerupButton!:Phaser.GameObjects.Container;
  private bumperButton!:Phaser.GameObjects.Container;
  private currentSteps!:TutorialStepsValues[];
  private currentTutorialStep!:TutorialStepsValues;
  private currentTutorialStepIndex:number = 0;
  private currentStepActive:boolean = false;
  private delayedNextStep:Phaser.Time.TimerEvent | undefined;
  private restartingTween:Phaser.Time.TimerEvent | undefined;
  private idleTimer:number = 0;
  private tutorialGuide!:Phaser.GameObjects.Container;
  private tutorialMask!:Phaser.GameObjects.Image;

  public setupTutorial(game:Game, taz:Taz, powerupButton:Phaser.GameObjects.Container, bumperButton:Phaser.GameObjects.Container, tutorialGuide:Phaser.GameObjects.Container, tutorialMask:Phaser.GameObjects.Image)
  {
    this.game = game;
    this.taz = taz;
    this.powerupButton = powerupButton;
    this.bumperButton = bumperButton;
    this.tutorialGuide = tutorialGuide;
    this.tutorialMask = tutorialMask;
    let mask = this.tutorialMask.createBitmapMask();
    mask.invertAlpha = true;
    this.tutorialGuide.mask = mask;
    this.tutorialMask.visible = false;

    if (this.scene.sys.game.device.os.desktop){
      this.hand.visible = false;
    }
    else
    {
      this.pointer.visible = false;
    }

  }

  public startTutorialStep(tutorialSteps: TutorialStepsValues[])
  {

    this.tutorialPointer.visible = false;

    this.currentSteps = tutorialSteps;

    this.currentTutorialStepIndex = 0;
    this.currentTutorialStep = tutorialSteps[this.currentTutorialStepIndex];
    this.delayedNextStep?.destroy();
    this.delayedNextStep = this.scene.time.delayedCall(2000, ()=>{this.startNextStep()}, undefined, this);
  }

  private startNextStep()
  {

    console.warn(this.currentTutorialStep);
    if(this.currentTutorialStep == TutorialSteps.MovePlayer)
    {
      this.currentStepActive = true;
      this.showMovePlayer();
    }
    // if(this.currentTutorialStep == TutorialSteps.pressBumper)
    // {
    //   this.currentStepActive = true;
    //   this.showBumper();
    // }
    // if(tutorialStep == TutorialSteps.PressPowerup)
    // {
    //   this.scene.time.delayedCall(2000, ()=>{this.showPowerup()}, undefined, this);
    // }
  }

  private delayBeforeNextStep:number = 1000;
  public update(time:number, delta:number)
  {

    if(this.currentTutorialStep == TutorialSteps.MovePlayerInMotion)
    {
      // console.log("Waiting for taz to slow down", this.currentStepActive);
      if(!this.currentStepActive)
      {
        // console.log("Waiting for taz to slow down", this.game.canReSpinTaz(), this.taz.velocity);
        if(this.game.canReSpinTaz() && this.taz.velocity > 0 && !this.game.mouseDown)
        {
          this.currentStepActive = true;
          this.showMovePlayer();
          // if(this.currentTutorialStep == TutorialSteps.MovePlayerInMotion && !this.completingStep)
          // {
          //   this.scene.events.emit("pausableTutorialStepStarted");
          // }
        }
      }
      // if(!this.currentStepActive)
      // {

      //   if(!this.game.canReSpinTaz() && this.taz.velocity > 0)
      //   {
      //       this.currentStepActive = true;
      //   //     this.startNextStep();
      //   }

      // }
      // else{
      //   // console.log(this.tutorialTween);
      //   if(this.tutorialTween == undefined)
      //   {
      //     console.log(this.game.canReSpinTaz(), this.taz.velocity);
      //     if(this.game.canReSpinTaz() && this.taz.velocity > 0)
      //     {
      //       // if(this.tutorialTween !== undefined)
      //       // {
      //       //   this.tutorialTween.stop();
      //       //   this.tutorialPointer.visible = false;
      //       //   this.tutorialTween = undefined;
      //       // }
      //       this.currentStepActive = false;
      //       this.startNextStep();
      //       // this.startNextStep();
      //     }
      //     // else
      //     // {
      //     //   if(this.tutorialTween == undefined)
      //     //   {
      //     //     this.currentStepActive = false;
      //     //   }
      //     // }
      //   }
      // }
    }

    if(this.currentTutorialStep == TutorialSteps.PressPowerup)
    {

      if(this.taz.velocity > 10 && !this.game.mouseDown)
      {
        this.delayBeforeNextStep -= delta;
        if(this.delayBeforeNextStep < 0)
        {
        if(this.tutorialTween == undefined)
        {
          if(this.currentTutorialStep == TutorialSteps.PressPowerup && !this.completingStep)
          {
            this.showPowerup();
            this.scene.events.emit(events.pausableTutorialStepStarted);
          }
        }
      }
      }
      else
      {
        if(this.tutorialTween != undefined)
        {
          this.tutorialTween.stop();
          this.tutorialPointer.visible = false;

          this.tutorialTween = undefined;
        }
      }
    }

    if(this.currentTutorialStep == TutorialSteps.PressBumper)
    {

      if(!this.game.canReSpinTaz() && this.taz.velocity > 10 && !this.game.mouseDown)
      {
        this.delayBeforeNextStep -= delta;
        if(this.delayBeforeNextStep < 0)
        {
          if(this.tutorialTween == undefined)
          {
            if(this.currentTutorialStep == TutorialSteps.PressBumper && !this.completingStep)
            {
              this.showBumper();
              this.scene.events.emit(events.pausableTutorialStepStarted);
            }
          }
        }
      }
      else
      {
        if(this.tutorialTween != undefined)
        {
          this.tutorialTween.stop();
          this.tutorialPointer.visible = false;

          this.tutorialTween = undefined;
        }
      }
    }

    if(this.currentTutorialStep != TutorialSteps.MovePlayer && this.currentTutorialStep != TutorialSteps.MovePlayerInMotion)
    {
      if(this.taz.velocity == 0 && this.game.canReSpinTaz())
      {
        
        if(this.idleTimer > 8000)
        {
          this.showIdleMovePlayer();
          this.idleTimer = 0;
        }
        else{
          this.idleTimer += delta;
        }
      }
      else
      {
        if(!this.currentStepActive)
        {
        this.tutorialPointer.visible = false;
        
        }
        this.idleTween?.stop();
        // this.restartingTween?.remove();
        this.idleTimer = 0;
      }
    }
  }

  private showIdleMovePlayer()
  {
    if(this.tutorialGuide.visible)
    {
      this.scene.add.tween({
        targets:this.tutorialGuide,
        alpha:0,
        duration:100,
        ease:Phaser.Math.Easing.Quadratic.InOut,
        onComplete:()=>{this.tutorialGuide.visible = false;}
      });
    }
    // this.currentStepActive = true;
    this.tutorialPointer.x = this.taz.x;
    this.tutorialPointer.y = this.taz.y;

    this.tutorialPointer.visible = true;
    this.tutorialPointer.alpha = 0;

    let x = this.taz.x + (this.taz.x <= 960 ? 200 : -200);
    let y = this.taz.y + (this.taz.y <= 384 ? 200 : -200);

    this.scene.events.emit(events.idlePrompt);
    console.log("show idle move player");

    this.idleTween?.stop();
    this.idleTween = this.scene.tweens.chain({
        targets:this.tutorialPointer,
        tweens:[
          {
            alpha:1,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            scale:0.8,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut,
          },
          {
            x:x,
            y:y,
            duration:1000,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            scale:1,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            alpha:0,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
        ]
    })
  }


  private showMovePlayer()
  {
    console.warn("Show move player");
    this.currentStepActive = true;
    this.tutorialPointer.x = this.taz.x;
    this.tutorialPointer.y = this.taz.y;

    this.tutorialPointer.visible = true;
    this.tutorialPointer.alpha = 0;

    this.scene.events.emit(events.idlePrompt);
    // this.tutorialGuide.visible = true;
    // this.tutorialGuide.alpha = 0;

    if(this.currentTutorialStep == TutorialSteps.MovePlayer)
    {
      if(!this.tutorialGuide.visible)
      {
        this.tutorialGuide.visible = true;
        this.tutorialGuide.alpha = 0;
        
        this.tutorialMask.x = this.tutorialPointer.x;
        this.tutorialMask.y = this.tutorialPointer.y;
        // this.tutorialGuide.scale = 2.37;
        
        this.scene.add.tween({
          targets:this.tutorialGuide,
          alpha:1,
          duration:100,
          ease:Phaser.Math.Easing.Quadratic.InOut
        });
      }
    }

    let x = this.taz.x + (this.taz.x <= 960 ? 200 : -200);
    let y = this.taz.y + (this.taz.y <= 384 ? 200 : -200);

    this.tutorialMask.x = this.taz.x;
    this.tutorialMask.y = this.taz.y;

    // this.scene.add.tween({
    //   targets:this.tutorialGuide,
    //   alpha:1,
    //   duration:100,
    //   ease:Phaser.Math.Easing.Quadratic.InOut
    // });

    this.tutorialTween?.stop();
    this.tutorialTween = this.scene.tweens.chain({
        targets:this.tutorialPointer,
        tweens:[
          {
            alpha:1,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            scale:0.8,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut,
          },
          {
            x:x,
            y:y,
            duration:1000,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            scale:1,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            alpha:0,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
        ]
    }).on("complete",()=>{this.waitThenRestartMovePlayer()});
  }

  private waitThenRestartMovePlayer()
  {
    this.restartingTween = this.scene.time.delayedCall(1000, ()=>{this.showMovePlayer()}, undefined, this);
  }

  private showPowerup()
  {
    console.warn("show powerup ", this.currentTutorialStep, this.completingStep);
    if(this.currentTutorialStep != TutorialSteps.PressPowerup || this.completingStep)
    {
      return;
    }
    // console.warn("show powerup");
    this.currentStepActive = true;
    this.tutorialPointer.x = this.powerupButton.parentContainer.x + this.powerupButton.x;
    this.tutorialPointer.y = this.powerupButton.parentContainer.y + this.powerupButton.y;

    if(!this.tutorialGuide.visible)
    {
      this.tutorialGuide.visible = true;
      this.tutorialGuide.alpha = 0;
      
      this.tutorialMask.x = this.tutorialPointer.x;
      this.tutorialMask.y = this.tutorialPointer.y;
      this.tutorialMask.scale = 0.3;

      this.scene.add.tween({
        targets:this.tutorialGuide,
        alpha:1,
        duration:100,
        ease:Phaser.Math.Easing.Quadratic.InOut
      });
    }

    this.tutorialPointer.visible = true;
    this.tutorialPointer.alpha = 0;
    this.tutorialTween?.stop();
    this.tutorialTween = this.scene.tweens.chain({
        targets:this.tutorialPointer,
        tweens:[
          {
            alpha:1,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            scale:0.8,
            duration:200,
            ease:Phaser.Math.Easing.Quadratic.InOut,
            onComplete: () => {
              UIButton.getComponent(this.powerupButton).manualPulse();
          },
          },
          {
            scale:1,
            duration:200,
            delay:200,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            alpha:0,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut,
            onComplete:()=>{this.waitThenRestartshowPowerup();}
          },
        ]
    })
  }

  private waitThenRestartshowPowerup()
  {
    console.warn("show powerup ", this.currentTutorialStep, this.completingStep);
    this.restartingTween = this.scene.time.addEvent({
      delay:1000,
      callback:()=>{
        console.warn("show powerup ", this.currentTutorialStep, this.completingStep);
        this.showPowerup()
      },
      callbackScope:this
    });
    // this.restartingTween = this.scene.time.delayedCall(1000, ()=>{this.showPowerup()}, undefined, this);
  }

  private showBumper()
  {
    if(this.currentTutorialStep != TutorialSteps.PressBumper || this.completingStep)
    {
      return;
    }
    console.warn("show powerup");
    this.currentStepActive = true;
    this.tutorialPointer.x = this.bumperButton.parentContainer.x + this.bumperButton.x;
    this.tutorialPointer.y = this.bumperButton.parentContainer.y + this.bumperButton.y;

    this.tutorialPointer.visible = true;
    this.tutorialPointer.alpha = 0;

    if(!this.tutorialGuide.visible)
    {
      this.tutorialGuide.visible = true;
      this.tutorialGuide.alpha = 0;
      
      this.tutorialMask.x = this.tutorialPointer.x;
      this.tutorialMask.y = this.tutorialPointer.y;
      this.tutorialMask.scale = 0.3;
      
      this.scene.add.tween({
        targets:this.tutorialGuide,
        alpha:1,
        duration:100,
        ease:Phaser.Math.Easing.Quadratic.InOut
      });
    }

    this.tutorialTween?.stop();
    this.tutorialTween = this.scene.tweens.chain({
        targets:this.tutorialPointer,
        tweens:[
          {
            alpha:1,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            scale:0.8,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut,
            onComplete: () => {
              UIButton.getComponent(this.bumperButton).manualPulse();
          },
          },
          {
            scale:1,
            duration:100,
            delay:200,
            ease:Phaser.Math.Easing.Quadratic.InOut
          },
          {
            alpha:0,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut,
            onComplete:()=>{this.waitThenRestartShowBumper();}
          },
        ]
    })
  }

  private waitThenRestartShowBumper()
  {
    this.restartingTween = this.scene.time.delayedCall(1000, ()=>{this.showBumper()}, undefined, this);
  }

  private completingStep:boolean = false;
  public completeTutorialStep(tutorialStep:TutorialStepsValues)
  {
    if(this.completingStep)
    {
      return;
    }

    if(tutorialStep == this.currentTutorialStep)
    {
      if(this.delayedNextStep != undefined)
      {
        this.delayedNextStep?.remove();
        this.currentStepActive = true;
      }

      this.scene.events.emit(events.tutorialStepCompleted);

      console.warn("complete tutorial step");
      this.tutorialTween?.stop();
      this.restartingTween?.remove();

      this.scene.add.tween({
        targets:this.tutorialGuide,
        alpha:0,
        duration:100,
        ease:Phaser.Math.Easing.Quadratic.InOut,
        onComplete:()=>{this.tutorialGuide.visible = false;}
      });

      console.log("complete tutorial step ",tutorialStep , this.currentTutorialStep);
      if(this.currentStepActive)
      { 
          this.currentStepActive = false;
          this.tutorialTween?.stop();
          this.tutorialPointer.visible = false;
          this.tutorialTween = undefined;

          this.scene.time.delayedCall(1000,()=>{this.delayedBeginNextStep();},undefined,this);
          this.completingStep = true;
      }
      else
      {
        //stop delayed call to nextstep.
        this.delayedNextStep?.remove();
        this.currentStepActive = true;
      }
    }
  }

  private delayedBeginNextStep()
  {
    this.delayBeforeNextStep = 1000;
    this.completingStep = false;
    this.currentTutorialStepIndex ++;
    // console.log("complete tutorial step ", tutorialStep ,this.currentTutorialStepIndex ,this.currentSteps.length);
    if(this.currentTutorialStepIndex < this.currentSteps.length) 
    {
      this.currentTutorialStep = this.currentSteps[this.currentTutorialStepIndex];
      console.log("starting tutorial step ", this.currentTutorialStep);
      this.delayedNextStep?.remove();
      this.startNextStep();
      // this.delayedNextStep = this.scene.time.delayedCall(2000, ()=>{this.startNextStep()}, undefined, this);
    }
    else
    {
      console.log("Completing all tutorial steps");
      this.currentTutorialStep = TutorialSteps.None;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
